import { useFormContext } from 'react-hook-form';

import type { FormPhoneInputProps } from '../types';
import type { FieldValues } from 'react-hook-form';

import { PhoneNumberInput } from '@/components/PhoneNumberInput';
import { Field, FieldDescription, FieldError } from '@/components/ui/field';
import { FormField } from '@/components/ui/form';

export const FormPhoneInput = <TFieldValues extends FieldValues = FieldValues>(
  props: FormPhoneInputProps<TFieldValues>,
) => {
  const {
    name,
    label,
    description,
    isRequired,
    defaultCountry = 'UA',
    disabled,
    control,
  } = props;

  const formContext = useFormContext<TFieldValues>();
  const formControl = control || formContext.control;

  const fieldId = `form-field-${String(name)}`;

  return (
    <FormField
      control={formControl}
      name={name}
      render={({ field, fieldState }) => {
        const fieldLabel = (
          <>
            {label}
            {isRequired && (
              <span
                className={
                  fieldState.invalid
                    ? 'text-destructive'
                    : 'text-muted-foreground'
                }
              >
                *
              </span>
            )}
          </>
        );

        return (
          <Field data-invalid={fieldState.invalid}>
            <PhoneNumberInput
              id={fieldId}
              value={field.value || ''}
              onChange={field.onChange}
              label={fieldLabel}
              defaultCountry={defaultCountry}
              disabled={disabled}
              isInvalid={fieldState.invalid}
            />
            {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
            {description && <FieldDescription>{description}</FieldDescription>}
          </Field>
        );
      }}
    />
  );
};
